import { base_colorAction, text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_size_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    width: 750px;
  }

  &.EnableVirtualCardsModal .BaseModal-Body {
    padding: ${spacing(15)};
  }

  .section-acknowledge {
    margin-top: ${spacing(5)};
  }

  .chevron {
    g,
    path {
      fill: gray;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .container-illustration {
    padding-bottom: ${spacing(5)};
  }

  .learn-more-text {
    font-size: ${font_size_md};
  }

  .Button.no-shell {
    box-shadow: none;
  }

  .legal-text {
    font-size: ${font_size_md};
    line-height: 20px;

    ul {
      padding-left: ${spacing(5)};
    }
  }

  .cancel-button {
    color: ${text_colorTextSecondary};
  }

  .confirm-button {
    padding: ${spacing(5)} ${spacing(7)};
  }

  .AlertPanel {
    margin-bottom: ${spacing(2)};
  }

  .error-link {
    color: ${base_colorAction};
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
`
